// extracted by mini-css-extract-plugin
export var blockTokenPrice = "BlockTokenPrice_blockTokenPrice__sZ1NT";
export var logo = "BlockTokenPrice_logo__CgJl0";
export var textLabel = "BlockTokenPrice_textLabel__RxNYh";
export var blockPrice = "BlockTokenPrice_blockPrice__L21TX";
export var textPrice = "BlockTokenPrice_textPrice__Q0vpq";
export var rotate = "BlockTokenPrice_rotate__FvnuX";
export var dotty = "BlockTokenPrice_dotty__6Vzwb";